export const newPermissions = Object.freeze({
  // Roster
  VIEW_ROSTER_PAGE: 'VIEW_ROSTER_PAGE',
  VIEW_ROSTER_LITE: 'VIEW_ROSTER_LITE',
  TRANSFER_MEMBER: 'TRANSFER_MEMBER',
  VIEW_ADVANCEMENT_TAB: 'VIEW_ADVANCEMENT_TAB',

  // Reports
  UNIT_ROSTER_REPORT: 'UNIT_ROSTER_REPORT',

  // Calendar/Events
  VIEW_CALENDAR_PAGE: 'VIEW_CALENDAR_PAGE',
  CRUD_EVENTS: 'CRUD_EVENTS',
  CRUD_SUB_EVENTS: 'CRUD_SUB_EVENTS',

  // Activities
  VIEW_ACTIVITY_PAGE: 'VIEW_ACTIVITY_PAGE',
  CRUD_ACTIVITIES: 'CRUD_ACTIVITIES',
  CRUD_SUB_ACTIVITIES: 'CRUD_SUB_ACTIVITIES',

  // Profiles
  VIEW_PROFILE_PAGE: 'VIEW_PROFILE_PAGE', // Own profile
  VIEW_YOUTH_PROFILE_PAGE: 'VIEW_YOUTH_PROFILE_PAGE',
  VIEW_ADULT_PROFILE_PAGE: 'VIEW_ADULT_PROFILE_PAGE',
  EDIT_PROFILE: 'EDIT_PROFILE', // (Unit youth profiles)
  EDIT_SUB_PROFILE: 'EDIT_SUB_PROFILE', // (My Sub-Unit youth profiles)
  EDIT_ADULT_PROFILE: 'EDIT_ADULT_PROFILE', // (Currently Parents or Leaders)
  EDIT_YOUTH_LEADERSHIP: 'EDIT_YOUTH_LEADERSHIP', // Program Leadership sidebar section
  VIEW_YOUTH_LEADERSHIP: 'VIEW_YOUTH_LEADERSHIP', // Program Leadership sidebar section
  VIEW_EDIT_SWIM_HEALTH_PROFILE: 'VIEW_EDIT_SWIM_HEALTH_PROFILE',
  VIEW_EDIT_JOINED_DATE_PROFILE: 'VIEW_EDIT_JOINED_DATE_PROFILE',
  SUBMIT_EAGLE_PROJECT: 'SUBMIT_EAGLE_PROJECT',
  VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION:
    'VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION',
  CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION:
    'CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION',
  DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION:
    'DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION',
  DELETE_PARENT_GUARDIAN_RELATIONSHIP: 'DELETE_PARENT_GUARDIAN_RELATIONSHIP',

  // Advancements
  EDIT_ADVANCEMENTS: 'EDIT_ADVANCEMENTS',
  APPROVE_ADVANCEMENTS: 'APPROVE_ADVANCEMENTS',
  AWARD_ADVANCEMENTS: 'AWARD_ADVANCEMENTS',
  EDIT_SUB_ADVANCEMENTS: 'EDIT_SUB_ADVANCEMENTS',
  APPROVE_SUB_ADVANCEMENTS: 'APPROVE_SUB_ADVANCEMENTS',
  AWARD_SUB_ADVANCEMENTS: 'AWARD_SUB_ADVANCEMENTS',
  EDIT_APPROVE_SCOUT: 'EDIT_APPROVE_SCOUT',
  EDIT_APPROVE_TENDERFOOT: 'EDIT_APPROVE_TENDERFOOT',
  EDIT_APPROVE_SECOND_CLASS: 'EDIT_APPROVE_SECOND_CLASS',
  EDIT_APPROVE_FIRST_CLASS: 'EDIT_APPROVE_FIRST_CLASS',
  EDIT_MB_ADVANCEMENTS: 'EDIT_MB_ADVANCEMENTS',
  SIGN_ON_BEHALF: 'SIGN_ON_BEHALF',
  ADVANCEMENT_HISTORY: 'ADVANCEMENT_HISTORY',

  // Finance
  CRUD_UNIT_LOG: 'CRUD_UNIT_LOG',
  CRUD_INDIV_LOG: 'CRUD_INDIV_LOG',
  CRUD_PO: 'CRUD_PO',
  VIEW_PO_PAGE: 'VIEW_PO_PAGE',
  CRUD_STRIPE: 'CRUD_STRIPE',

  // Leadership - Permissions manager page
  VIEW_PERMISSIONS_MANAGER: 'VIEW_PERMISSIONS_MANAGER_PAGE',
  // Called ACCEPT_LEADER before
  EDIT_LEADER: 'EDIT_LEADER',
  // Called APPROVE_LEADER before
  EDIT_LEADER_RESTRICTED: 'EDIT_LEADER_RESTRICTED',

  // Membership
  INACTIVE_YOUTH_MEMBERS: 'INACTIVE_YOUTH_MEMBERS',
  INACTIVE_ADULT_MEMBERS: 'INACTIVE_ADULT_MEMBERS',

  // Messaging
  VIEW_MESSAGING: 'VIEW_MESSAGING',
  CRUD_MESSAGING_GROUP: 'CRUD_MESSAGING_GROUP',

  // Unit
  VIEW_REPORTS_PAGE: 'VIEW_REPORTS_PAGE',
  EDIT_UNIT: 'EDIT_UNIT', // Mostly used to indicate CRUD Sub unit
  EDIT_SUB_UNIT: 'EDIT_SUB_UNIT', // Mostly used to indicate permissions over assigned sub units
  ADD_DEN_CHIEF: 'ADD_DEN_CHIEF',
  EDIT_UNIT_SETTINGS: 'EDIT_UNIT_SETTINGS',

  // Youth
  VIEW_SELF_YOUTH_PROFILE: 'VIEW_SELF_YOUTH_PROFILE',

  // Council
  VIEW_COUNCIL_UNITS_PAGE: 'VIEW_COUNCIL_UNITS_PAGE',

  // MISC
  MASQUERADE: 'MASQUERADE',
  SHOW_FORUM_LINK: 'SHOW_FORUM_LINK',
  SHOW_SCOUTBOOK_LINK: 'SHOW_SCOUTBOOK_LINK',
  INVITE_MEMBERS_TO_RECHARTER: 'INVITE_MEMBERS_TO_RECHARTER',
  EDIT_BANNER: 'EDIT_BANNER',

  // SBL-6024 TODO: Remove all uses of Edit data and change it for the advancement/awards permissions
  //TODO EDIT_DATA was used as a cache all permission for activities and advancements (DO NOT USE IT), remove any use you find
  EDIT_DATA: 'EDIT_DATA',

  //MBC related
  EDIT_MBC: 'EDIT_MBC', //TODO: EDIT_MBC doesn't seem to be in use, and it might not be used
  VIEW_MERIT_BADGE_COUNSELORS_PAGE: 'VIEW_MERIT_BADGE_COUNSELORS_PAGE',
  VIEW_COUNSELED_YOUTH: 'VIEW_COUNSELED_YOUTH',
  VIEW_MBC_DASHBOARD: 'VIEW_MBC_DASHBOARD',
  ASSIGN_MBC_IN_YOUTH_PROFILE: 'ASSIGN_MBC_IN_YOUTH_PROFILE',
  REMOVE_MBC_IN_YOUTH_PROFILE: 'REMOVE_MBC_IN_YOUTH_PROFILE',
  MBC_TABLE_EDIT_ASSIGN: 'MBC_TABLE_EDIT_ASSIGN', //Used in counselor search table
});

// Do not create "groups" of permissions like this one unless there are multiple positions with the same permissions
const baseCouncilPermissions = {
  // Roster
  [newPermissions.VIEW_ROSTER_PAGE]: true,

  // Calendar
  [newPermissions.VIEW_CALENDAR_PAGE]: true,

  // Activities
  [newPermissions.VIEW_ACTIVITY_PAGE]: true,

  // Profiles
  [newPermissions.VIEW_PROFILE_PAGE]: true,
  [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
  [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,
  [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
  [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,

  // Unit
  [newPermissions.VIEW_REPORTS_PAGE]: true,

  // Council
  [newPermissions.VIEW_COUNCIL_UNITS_PAGE]: true,

  // MISC
  [newPermissions.SHOW_FORUM_LINK]: true,
  [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

  // MBC
  [newPermissions.EDIT_MBC]: true,
  [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
};

// Only add true values
export const newRolePermissions = {
  'Chartered Organization Rep.': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Assistant Scoutmaster': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancement
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Unit Advancement Chair': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Advancements
    [newPermissions.SIGN_ON_BEHALF]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Committee Chair': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  Scoutmaster: {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Council Unit Representative': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'COR/CUR Delegate': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Key 3 Delegate': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Unit Support': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_SUB_UNIT]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Unit Merit Badge administrator': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Advancements
    [newPermissions.SIGN_ON_BEHALF]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Calendar Editor': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Unit Outdoors / Activities chair': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Unit Treasurer': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'New Member Coordinator': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Unit Chaplain': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancement
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Unit Religious Emblems Coord': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  Secretary: {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Unit Training Chair': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Youth Protection Champion': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Youth Member': {
    // Roster TODO: SBL-6255
    // [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.SHOW_FORUM_LINK]: true,
  },
  'Assistant Cubmaster': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  Cubmaster: {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Den Leader': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_SUB_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_SUB_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_SUB_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_SUB_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_SUB_ADVANCEMENTS]: true,
    [newPermissions.AWARD_SUB_ADVANCEMENTS]: true,

    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_SUB_UNIT]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // PO
    [newPermissions.CRUD_PO]: true,
  },
  'Den Support': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_SUB_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_SUB_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_SUB_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_SUB_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_SUB_ADVANCEMENTS]: true,
    [newPermissions.AWARD_SUB_ADVANCEMENTS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_SUB_UNIT]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,
    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Asst. Den Leader': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_SUB_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Committee Member': {
    // Roster
    [newPermissions.VIEW_ROSTER_LITE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Unit College Scouter Reserve': {
    // Roster
    [newPermissions.VIEW_ROSTER_LITE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  'Unit Scouter Reserve': {
    // Roster
    [newPermissions.VIEW_ROSTER_LITE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Venturing Crew Advisor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  Skipper: {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Venturing Crew Assoc. Advisor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancement
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  Mate: {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancement
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Registration Inquiry': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Digital Product Sale Manager': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Venturing College Sctr Reserve': {
    // Roster
    [newPermissions.VIEW_ROSTER_LITE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Executive Officer': {
    // Roster
    [newPermissions.VIEW_ROSTER_LITE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  'Club Sponsor': {
    [newPermissions.VIEW_ROSTER_LITE]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // FINANCE
    [newPermissions.CRUD_STRIPE]: true,
  },
  'Explorer Post Advisor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Calendar Editor by SubUnit': {
    // Roster

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_SUB_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
  },
  'Activity Approver/Creator/Remover/Editor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Sub-Unit Support': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_SUB_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_SUB_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_SUB_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_SUB_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_SUB_ADVANCEMENTS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_SUB_UNIT]: true,

    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Profile Editor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Advancement Awarder': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,

    // Advancements
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Advancement Approver': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Advancement Editor (includes Youth Leadership)': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.SIGN_ON_BEHALF]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Scout Requirement Editor/Approver (NO SM)': {
    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,

    // Advancements
    [newPermissions.EDIT_APPROVE_SCOUT]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Tenderfoot Requirement Editor/Approver (NO SM NO BOR)': {
    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,

    // Advancements
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  'Second Class Requirement Editor/Approver (NO SM NO BOR)': {
    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,

    // Advancements
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  'First Class Requirement Editor/Approver (NO SM NO BOR)': {
    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,

    // Advancements
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  'P.O. Creator/Editor': {
    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Create Messages': {
    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Create/Delete/Edit Message Groups': {
    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'MBC List': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // // Advancements
    [newPermissions.SIGN_ON_BEHALF]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Parent/Guardian': {
    // Roster TODO: SBL-6255
    // [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.SHOW_FORUM_LINK]: true,
  },

  // Council roles
  'District Executive': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'District Director': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Senior District Executive': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Field Director': {
    ...baseCouncilPermissions,
    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Director Field Service': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Assistant Scout Executive': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'National Admin': {
    // MISC
    [newPermissions.EDIT_BANNER]: true,
  },
  'National Commissioner Service': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'National Scout Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Council Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Assistant Council Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'District Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Asst. District Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Roundtable Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Asst Roundtable Commissioner': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Unit Commissioner': {
    ...baseCouncilPermissions,
    // Roster
    [newPermissions.VIEW_ADVANCEMENT_TAB]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'District Service Team Chair': {
    ...baseCouncilPermissions,
    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  // Removed council roles (Uncomment if needed)
  // 'Regional Commissioner': baseCouncilPermissions,
  // 'Assistant Regional Commissioner': baseCouncilPermissions,
  // 'Area Commissioner': baseCouncilPermissions,
  // 'Area Committee Chairman': baseCouncilPermissions,

  // Council with editing rights
  'Scout Executive': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Exploring Executive': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },

  'Council Admin': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,

    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.EDIT_BANNER]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },

  'Council Advancement Committee Chair': {
    ...baseCouncilPermissions,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.MBC_TABLE_EDIT_ASSIGN]: true,
  },
  'District Advancement Chair': {
    ...baseCouncilPermissions,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.MBC_TABLE_EDIT_ASSIGN]: true,
  },
  //Copy District Advancement Chair
  'District Advancement Committee Chair': {
    ...baseCouncilPermissions,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.MBC_TABLE_EDIT_ASSIGN]: true,
  },
  'District Advancement Committee Member': {
    //-- Start baseCouncilPermissions,
    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,

    // Council
    [newPermissions.VIEW_COUNCIL_UNITS_PAGE]: true,
    //-- End baseCouncilPermissions

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.MBC_TABLE_EDIT_ASSIGN]: true,
  },
  'Council Advancement Committee Member': {
    ...baseCouncilPermissions,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.MBC_TABLE_EDIT_ASSIGN]: true,
  },

  // These are old positions, they might be removed in the future
  'Merit Badge Counselor': {
    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_MBC_DASHBOARD]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.VIEW_COUNSELED_YOUTH]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Advancements
    [newPermissions.EDIT_MB_ADVANCEMENTS]: true,
  },
  // Copy 3 Key Delegate
  'Key 3': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  // Copy 3 Key Delegate
  'Unit Key 3': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  // Copy Unit Outdoors / Activities chair
  'Unit Outdoors': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  // Copy Unit Outdoors / Activities chair
  'Activities Chair': {
    // Roster

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  // Note: This might be a legacy position, but the equivalents are Pack Admin, Troop Admin, Crew Admin, Ship Admin, Post Admin
  'Unit Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  // Copy Unit Admin
  'Pack Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Troop Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Crew Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Ship Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Post Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Den Chief': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_SUB_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  // Copy Secretary
  'Committee Secretary': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  // Copy Venturing Crew Assoc. Advisor
  'Associate Crew Advisor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Associate Sponsor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Post Associate Advisor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  'Post - Explorer Post Associate Advisor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // Advancements
    [newPermissions.ADVANCEMENT_HISTORY]: true,
  },
  'Explorer Post Admin': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Exploring Sponsor': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,
    [newPermissions.CRUD_STRIPE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  'Post Committee Chairman': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },

  'Post Committee Chair': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Post Committee Member': {
    // Roster
    [newPermissions.VIEW_ROSTER_LITE]: true,

    // Calendar
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
  },
  // Copy COR/CUR Delegate
  'COR Delegate': {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,
    [newPermissions.CRUD_EVENTS]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,

    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  // Copy Key 3 Delegate
  Advancement: {
    // Roster
    [newPermissions.VIEW_ROSTER_PAGE]: true,
    [newPermissions.TRANSFER_MEMBER]: true,

    // Reports
    [newPermissions.UNIT_ROSTER_REPORT]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_ADULT_PROFILE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.VIEW_EDIT_SWIM_HEALTH_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER_RESTRICTED]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Council Key 3': baseCouncilPermissions,
  'Assistant Director of Field Service': {
    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Director of Field Service': {
    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Registration Support': {
    ...baseCouncilPermissions,

    // Roster
    [newPermissions.TRANSFER_MEMBER]: true,

    // Activities (View is in the base)

    // Profiles
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,
    [newPermissions.APPROVE_ADVANCEMENTS]: true,
    [newPermissions.AWARD_ADVANCEMENTS]: true,
    [newPermissions.EDIT_APPROVE_SCOUT]: true,
    [newPermissions.EDIT_APPROVE_TENDERFOOT]: true,
    [newPermissions.EDIT_APPROVE_FIRST_CLASS]: true,
    [newPermissions.EDIT_APPROVE_SECOND_CLASS]: true,
    [newPermissions.ADVANCEMENT_HISTORY]: true,

    // Finance
    [newPermissions.CRUD_UNIT_LOG]: true,
    [newPermissions.CRUD_INDIV_LOG]: true,
    [newPermissions.CRUD_PO]: true,
    [newPermissions.VIEW_PO_PAGE]: true,

    // Leadership
    [newPermissions.VIEW_PERMISSIONS_MANAGER]: true,
    [newPermissions.EDIT_LEADER]: true,

    // Membership
    [newPermissions.INACTIVE_YOUTH_MEMBERS]: true,
    [newPermissions.INACTIVE_ADULT_MEMBERS]: true,

    // Messaging
    [newPermissions.VIEW_MESSAGING]: true,
    [newPermissions.CRUD_MESSAGING_GROUP]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,
    [newPermissions.EDIT_UNIT]: true,
    [newPermissions.EDIT_UNIT_SETTINGS]: true,
    [newPermissions.ADD_DEN_CHIEF]: true,

    // MISC
    [newPermissions.SHOW_FORUM_LINK]: true,
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
    [newPermissions.ASSIGN_MBC_IN_YOUTH_PROFILE]: true,
    [newPermissions.REMOVE_MBC_IN_YOUTH_PROFILE]: true,
  },
  'Council Merit Badge Administrator': {
    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,

    // MBC
    [newPermissions.EDIT_MBC]: true,
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'Assistant District Executive': {
    // MBC
    [newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE]: true,
  },
  'District Merit Badge Administrator': {
    ...baseCouncilPermissions,
  },
  // Copy Youth Member
  Youth: {
    // Roster TODO: SBL-6255
    // [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
  },
  // Copy Parent/Guardian
  Parent: {
    // Roster TODO: SBL-6255
    // [newPermissions.VIEW_ROSTER_PAGE]: true,

    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.EDIT_PROFILE]: true,
    [newPermissions.VIEW_EDIT_JOINED_DATE_PROFILE]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.CREATE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP_INVITATION]: true,
    [newPermissions.DELETE_PARENT_GUARDIAN_RELATIONSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // Unit
    [newPermissions.VIEW_REPORTS_PAGE]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.SHOW_FORUM_LINK]: true,
  },
  //Copy youth member for any paricipant position
  'Unit Participant': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.SHOW_FORUM_LINK]: true,
  },
  'Venturing Participant': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.SHOW_FORUM_LINK]: true,
  },
  'Exploring Participant': {
    // Calendar/Events
    [newPermissions.VIEW_CALENDAR_PAGE]: true,

    // Activities
    [newPermissions.VIEW_ACTIVITY_PAGE]: true,
    // This perm is limited in the youth profile
    [newPermissions.CRUD_ACTIVITIES]: true,

    // Profiles
    [newPermissions.VIEW_PROFILE_PAGE]: true,
    [newPermissions.VIEW_SELF_YOUTH_PROFILE]: true,
    [newPermissions.VIEW_YOUTH_PROFILE_PAGE]: true,
    [newPermissions.VIEW_ADULT_PROFILE_PAGE]: true,
    [newPermissions.SUBMIT_EAGLE_PROJECT]: true,
    [newPermissions.EDIT_YOUTH_LEADERSHIP]: true,
    [newPermissions.VIEW_YOUTH_LEADERSHIP]: true,

    // Advancements
    [newPermissions.EDIT_ADVANCEMENTS]: true,

    // MISC
    [newPermissions.SHOW_SCOUTBOOK_LINK]: true,
    [newPermissions.SHOW_FORUM_LINK]: true,
  },

  // These are old positions (Mostly from Scout Book) and are going to be ignored, add them back if needed.
  // Chartered Organization Rep Delegate (We have COR/CUR Delegate now)
  // Committee Chairman (We have Committee Chair now)
  // Explorer Club Admin
  // Exploring Advisor
  // Exploring Sponsor
  // IA Edit Calendar (We have Calendar Editor now)
  // Patrol Admin
  // Den Admin
  // Den Administration
  // Assistant Webelos Den Leader
  // Webelos Asst. Den Leader
  // Webelos Assistant Den Leader
  // Webelos Den Leader
  // Tiger Den Leader
};
